var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadDrop1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit_1_",
    "data-name": "edit (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.55,
    height: 17.55,
    viewBox: "0 0 17.55 17.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4535",
    "data-name": "Path 4535",
    d: "M13.894,91.666a.731.731,0,0,0-.731.731v5.85a.732.732,0,0,1-.731.731H2.194a.732.732,0,0,1-.731-.731V88.01a.732.732,0,0,1,.731-.731h5.85a.731.731,0,0,0,0-1.463H2.194A2.2,2.2,0,0,0,0,88.01V98.248a2.2,2.2,0,0,0,2.194,2.194H12.431a2.2,2.2,0,0,0,2.194-2.194V92.4a.731.731,0,0,0-.731-.731Zm0,0",
    transform: "translate(0 -82.892)",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4536",
    "data-name": "Path 4536",
    d: "M182.433,74.048a.371.371,0,0,0-.1.186l-.517,2.586a.365.365,0,0,0,.359.437.348.348,0,0,0,.072-.007l2.585-.517a.364.364,0,0,0,.187-.1l5.786-5.786-2.585-2.585Zm0,0",
    transform: "translate(-175.577 -65.939)",
    fill: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4537",
    "data-name": "Path 4537",
    d: "M395.042,1.036a1.829,1.829,0,0,0-2.585,0l-1.012,1.012,2.585,2.585,1.012-1.012a1.828,1.828,0,0,0,0-2.585Zm0,0",
    transform: "translate(-378.028 -0.501)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadDrop1);
export default __webpack_public_path__ + "static/media/head-drop1.724a2dc29e6462d1ec46590d5660696a.svg";
export { ForwardRef as ReactComponent };